import { endsAfterMidnight } from '../../utils/endsAfterMidnight';
import { getSlotsCount } from './calculateClashedPeriods';

export const getStructureSlotRange = (
  startTime?: string,
  endTime?: string,
  allDaySlotsCount = 72
): { startSlot: number; endSlot: number; slotsCount: number } => {
  const startSlot = getSlotsCount(startTime);
  const rawEndSlot = getSlotsCount(endTime);
  const endSlot =
    startTime && endTime && endsAfterMidnight(startTime, endTime)
      ? rawEndSlot + allDaySlotsCount
      : rawEndSlot;

  return { startSlot, endSlot, slotsCount: endSlot - startSlot };
};
